'use strict';

module.exports = /* @ngInject */ function (apiConfig, httpService) {

    function getBase() {
        return `${apiConfig.$get().apiUrl}/rfq`
    }

    function getCustomerCompanyIdByRfqNumber(rfqNumber) {
        const url = `${getBase()}/${rfqNumber}/customer`;
        return httpService.get(url, {
            transformResponse: function (data) {
                return {
                    id: data
                }
            },
            cache: true
        });
    }

    return {
        getCustomerCompanyIdByRfqNumber
    }

}
